import type React from "react"
import {
  Command as CommandBase,
  CommandInput as CommandInputBase,
  CommandList as CommandListBase,
  CommandEmpty as CommandEmptyBase,
  CommandGroup as CommandGroupBase,
  CommandItem as CommandItemBase,
} from "@love-irish/ui-components/command"
import {
  Popover as PopoverBase,
  PopoverAnchor as PopoverAnchorBase,
  PopoverContent as PopoverContentBase,
} from "@love-irish/ui-components/popover"

// The base-UI primitives are typed against ui-components' own copy of @types/react, whose element types
// don't line up with this package's copy (a monorepo type-duplication quirk — the same reason
// core-button/core-avatar/MockedProvider get cast to loose FCs). Re-export the ones we use, cast once
// here, so the components below can render them as JSX without per-file casts. Props stay runtime-forwarded.
const asFC = (component: unknown): React.FC<Record<string, any>> =>
  component as React.FC<Record<string, any>>

export const Command = asFC(CommandBase)
export const CommandInput = asFC(CommandInputBase)
export const CommandList = asFC(CommandListBase)
export const CommandEmpty = asFC(CommandEmptyBase)
export const CommandGroup = asFC(CommandGroupBase)
export const CommandItem = asFC(CommandItemBase)
export const Popover = asFC(PopoverBase)
export const PopoverAnchor = asFC(PopoverAnchorBase)
export const PopoverContent = asFC(PopoverContentBase)
